import { render, staticRenderFns } from "./relationa.vue?vue&type=template&id=ff6827f2&scoped=true&"
import script from "./relationa.vue?vue&type=script&lang=js&"
export * from "./relationa.vue?vue&type=script&lang=js&"
import style0 from "./relationa.vue?vue&type=style&index=0&id=ff6827f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6827f2",
  null
  
)

export default component.exports